import UserView from "./UserView.vue"
import UserList from "./UserList.vue"

const base = "/user"

export default [
    {
        path: base + "/:uuid",
        name: "userdetailform",
        props: true,
        component: UserView
    },
    {
        path: "/users",
        name: "userlist",
        props: true,
        component: UserList
    },
]
